import { render, staticRenderFns } from "./AboutViewSide.vue?vue&type=template&id=d692d622&"
import script from "./AboutViewSide.vue?vue&type=script&lang=js&"
export * from "./AboutViewSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports